import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import Widget from '@/components/common/widget';
import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';
import type { GetEventSettingsDto } from '@/types/dtos/events/response/get-event-settings.dto';
import { useTranslations } from '@/i18n/use-translations';
import FlowMediaSettingsPanel from './flow-media-settings-panel';
import FlowPlayoutSettingsPanel from './flow-playout-settings-panel';

type FlowSettingsWidgetTab = 'media' | 'playout';

const compactTabsSx = {
  'minHeight': 32,
  '& .MuiTabs-flexContainer': {
    minHeight: 32,
  },
  '& .MuiTabs-indicator': {
    bottom: 0,
  },
};

const compactTabSx = {
  minHeight: 32,
  py: 0,
  px: 0,
  minWidth: 0,
};

export default function FlowSettingsWidget({
  flow,
  eventSettings,
  multiFlow = false,
}: {
  flow: FlowDto;
  eventSettings?: GetEventSettingsDto | null;
  multiFlow?: boolean;
}) {
  const t = useTranslations();
  const [tab, setTab] = useState<FlowSettingsWidgetTab>('media');

  return (
    <Widget title={t('flows.detail.settings.title')}>
      <Tabs value={tab} onChange={(_, value: FlowSettingsWidgetTab) => setTab(value)} sx={compactTabsSx}>
        <Tab value="media" label={t('event.detail.settingsMenu.media.title')} sx={compactTabSx} />
        {multiFlow ? (
          <Tab
            value="playout"
            label={t('event.detail.settingsMenu.playout.title', { defaultValue: 'Playout' })}
            sx={compactTabSx}
          />
        ) : null}
      </Tabs>
      <Box sx={{ pt: 2 }}>
        {tab === 'media' ? (
          <FlowMediaSettingsPanel flow={flow} eventSettings={eventSettings} multiFlow={multiFlow} />
        ) : null}
        {tab === 'playout' && multiFlow ? <FlowPlayoutSettingsPanel flow={flow} /> : null}
      </Box>
    </Widget>
  );
}
